// Utility functions for calculators

/**
 * Format a number as currency with commas and decimals (default 0 decimals)
 * @param {number|string} value
 * @param {number} decimals
 * @returns {string}
 */
export function formatCurrency(value, decimals = 0) {
  if (value === null || value === undefined || value === "") return "0";
  const num =
    typeof value === "string" ? parseFloat(value.replace(/,/g, "")) : value;
  if (isNaN(num)) return "0";
  return num.toLocaleString("en-GB", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}
// export const formatCurrency = (value) => {
//   if (isNaN(value)) return value;
//   return new Intl.NumberFormat("en-GB", {
//     style: "currency",
//     currency: "GBP",
//   }).format(value);
// };

export const parseNumericValue = (value) => {
  return Number(String(value || "").replace(/[^\d.]/g, ""));
};